import { Box, Grid, Typography } from '@mui/material';

// Buyer/Supplier form look (Account-form style): outlined fields, left-aligned section headings,
// responsive columns. Scoped to the party forms so Address/Legal/Bank/Lead keep their look elsewhere.
export const partyFormSx = {
  '& .c-text-field': {
    backgroundColor: '#fff !important',
    border: '1px solid #6b7280 !important',
    borderRadius: '10px !important',
    paddingLeft: '8px !important',
    paddingRight: '8px !important',
    paddingTop: '0 !important',
    minHeight: 35,
    mt: 0.5,
    justifyContent: 'center',
    '& .MuiInputBase-root': { minHeight: 33, alignItems: 'center' },
    '& .MuiInputBase-input, & .MuiSelect-select': { py: 0, textAlign: 'left' },
  },
  '& .c-label': { margin: 0 },
  '& p:empty': { display: 'none' },
  // Divider + Chip section headings -> plain heading with a bottom rule.
  '& .MuiDivider-root.MuiDivider-withChildren': {
    display: 'block',
    margin: '0 !important',
    borderBottom: '1px solid #e4e4e4',
    pb: 1,
    '&::before, &::after': { display: 'none' },
    textAlign: 'left',
    '& .MuiDivider-wrapper': { p: 0, display: 'inline-flex' },
    '& .MuiFormControlLabel-root': { ml: '8px !important', mr: 0 },
    '& .MuiCheckbox-root': { p: 0, mr: 0.75 },
    '& .MuiChip-root': { height: 'auto', backgroundColor: 'transparent', '& .MuiChip-label': { p: 0 } },
    '& .MuiChip-label, & .MuiChip-label .MuiTypography-root': { fontWeight: 600, fontSize: '15px', color: '#1a1a1a' },
  },
  // Fixed-width columns from the shared parts: 2 per row on tablets, 1 on phones.
  '@media (min-width: 900px)': { '& .addr-col .MuiGrid-item:not(.full-row)': { flexBasis: '33.333%', maxWidth: '33.333%' } },
  '@media (max-width: 900px)': {
    '& .MuiGrid-item': { flexBasis: '50%', maxWidth: '50%' },
    '& .full-row, & .MuiGrid-item:has(> .MuiDivider-root)': { flexBasis: '100% !important', maxWidth: '100% !important' },
  },
  '@media (max-width: 600px)': { '& .MuiGrid-item': { flexBasis: '100%', maxWidth: '100%', borderLeft: 'none !important' } },
};


export const PartySection = ({ heading }: { heading: string }) => (
  <Grid item xs={12} className="full-row" sx={{ mt: 0.5 }}>
    <Box sx={{ borderBottom: '1px solid #e4e4e4', pb: 0.75 }}>
      <Typography sx={{ fontWeight: 600, fontSize: '15px', color: '#1a1a1a' }}>{heading}</Typography>
    </Box>
  </Grid>
);
